/* eslint-disable no-console */
import { UI, UserSettings } from '@leverege/ui-redux';
import { ApiUserSettingsDelegate, Project } from '@leverege/api-redux';
import { Config } from '@leverege/plugin';
import { matchPath } from 'react-router';
import I18N from '@leverege/i18n';
import { History, UserRoles, Constants } from '@leverege/molten-core';
import MoltenUtil from "../../MoltenUtil.js";
const {
  USER_SETTINGS_FALLBACK_MUTATOR
} = Constants;
const {
  t
} = I18N.ns('molten.startup.plugins.ApiUserSettings');
/**
 * OnLogged, this will load blueprints, networks*, roles, and enums into redux
 * 
 * * TBD
 */

export default {
  id: 'molten.ApiUserSettings',
  sort: -50,
  onLoggedIn: async (molten, action) => {
    const store = molten.get('store');
    const api = molten.get('api');
    const uiName = molten.getConfig('uiName');
    const prjId = api.options.projectId;
    const sysId = api.options.systemId;
    const {
      dispatch
    } = store;
    const roles = await api.project(prjId).account(action.profile.id).roles({
      format: 'uniqueRoles'
    });
    if (roles?.items?.length > 0) {
      roles.items.forEach(r => store.dispatch(Project(r?.projectId).role(r?.id).get({
        includePermissions: true
      })));
    }
    const allUserRoles = UserRoles.extract(roles?.items);
    const isForbidden = roles?.items?.every(UserRoles.createBlockedFromPredicate(molten));
    if (isForbidden) {
      // Effectively logs the user out without redirecting us to the login page
      localStorage.removeItem('id_token');
      localStorage.removeItem('refresh_token');
      window.location.href = '/forbidden';
    }
    const personas = roles?.items?.filter(UserRoles.createUIRoleFilter(molten)) || [];
    const hasDefault = Object.values(allUserRoles || {}).some(r => r?.isAdmin);
    // Sort personas
    personas.sort(sortRoles);
    if (hasDefault) {
      personas.unshift({
        name: 'default',
        displayName: t('default')
      });
    }
    const match = matchPath(window.location.pathname, {
      path: History.adjustPath(molten.getConfig('personaUrl', '/p/:persona')),
      // path : adjustPath( Config.get( 'BlueprintRoutes', 'baseUrl', '/p/:persona' ) ),

      exact: false
    });
    const urlPersona = match?.params?.persona;
    const activePersona = urlPersona && personas.find(p => urlPersona === p.name) ||
    // from url
    personas[0] ||
    // from first in list
    {
      name: 'default',
      displayName: t('default')
    } // default
    ;
    const plgs = MoltenUtil.sortedPlugins(USER_SETTINGS_FALLBACK_MUTATOR);
    let fallback = [{
      ownerId: action.profile.id,
      ownerType: 'user'
    }, {
      ownerId: sysId,
      ownerType: 'system',
      projectId: prjId
    }];
    const cxt = {
      systemId: sysId,
      projectId: prjId,
      user: action.profile,
      personas
    };
    for (let i = 0; i < plgs.length; i++) {
      const plg = plgs[i];
      // eslint-disable-next-line no-await-in-loop
      fallback = (await plg.mutate(fallback, cxt)) || fallback;
    }
    const Delegate = Config.get('UserSettings', 'delegate', ApiUserSettingsDelegate);
    UserSettings.setDelegate(new Delegate({
      fallback,
      dispatch,
      profile: activePersona.name,
      basePath: uiName == null ? 'ui' : uiName
    }));
    UserSettings.preloadAll();
    dispatch(UI.multiSet({
      personas,
      activePersona,
      allUserRoles
    }));
  },
  onLoggedOut: async molten => {
    const store = molten.get('store');
    store.dispatch(UI.multiSet({
      userRoles: null,
      activeRole: null
    }));
  }
};
function sortRoles(a, b) {
  const as = a.metadata?.priority == null ? 1000 : a.metadata.priority;
  const bs = b.metadata?.priority == null ? 1000 : b.metadata.priority;
  if (as === bs) {
    const an = (a.displayName || a.name).toLowerCase();
    const bn = (b.displayName || b.name).toLowerCase();
    if (an === bn) {
      return 0;
    }
    return an < bn ? -1 : 1;
  }
  return as - bs;
}